import { render, staticRenderFns } from "./modifyPhone.vue?vue&type=template&id=135eaac8&scoped=true"
import script from "./modifyPhone.vue?vue&type=script&lang=js"
export * from "./modifyPhone.vue?vue&type=script&lang=js"
import style0 from "./modifyPhone.vue?vue&type=style&index=0&id=135eaac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135eaac8",
  null
  
)

export default component.exports